import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ParentButtonComponent } from '../../../../shared/components/ui/parent-button/parent-button.component';

@Component({
  selector: 'app-parent-learn-enroll-card',
  standalone: true,
  imports: [CommonModule, TranslatePipe, ParentButtonComponent],
  templateUrl: './parent-learn-enroll-card.component.html',
  styleUrl: './parent-learn-enroll-card.component.scss',
})
export class ParentLearnEnrollCardComponent {
  joined = input(false);
  completed = input(false);
  joinLoading = input(false);
  leaveLoading = input(false);

  join = output<void>();
  leave = output<void>();
}
